import { isRuleOrGroupValid } from "react-querybuilder"
import { isRuleValueValid, ruleValidation } from "./reportValidations"

//https://react-querybuilder.js.org/docs/components/querybuilder#independent-combinators
//converts react query's independent-combinator format (rules: [{ rule1 }, "and", { rule2 }, "or" ...])
// into a flat rule array (rules: [{ rule1, combinator: "and" }, { rule2, combinator: "or" } ...])
// so C# can parse it 

//returns a query object with formatted updated rules
const processIndependentCombinatorRules = (rulesArray, tables = null) => {
    const processedRules = []

    for (let i = 0; i < rulesArray.length; i += 2) {
        const rule = rulesArray[i]
        const combinator = i + 1 < rulesArray.length ? rulesArray[i + 1] : null
        // Add combinator to the rule
        const processedRule = {
            ...rule,
            combinator: combinator || null,
            // table: tables || rule.table
        }

        // Process nested rules if they exist
        if (rule.rules) {
            processedRule.rules = processIndependentCombinatorRules(rule.rules)
        }

        processedRules.push(processedRule)
    }

    return processedRules
}

//undo the processIndependentCombinatorRules formating to allow 
// react query builder to properly process our query 
const restoreRuleToIndependentCombinatorForm = (processedRules) => {
    const originalArray = []

    processedRules.forEach((rule, index) => {
        // Add the rule itself
        const { combinator, rules, ...originalRule } = rule
        originalArray.push(originalRule)

        // Add the combinator if it exists and we're not at the last rule
        if (combinator && index < processedRules.length - 1) {
            originalArray.push(combinator)
        }

        // Process nested rules if they exist
        if (rules) {
            originalRule.rules = restoreRuleToIndependentCombinatorForm(rules)
        }
    })

    return originalArray
}

const joinRuleProcessor = (rule, fields) => {
    try {
        const valueAsArray = rule.value?.split(',')
        if (valueAsArray && isRuleValueValid(valueAsArray[0]) && isRuleValueValid(valueAsArray[1])) {
            const validation = ruleValidation(rule)
            const newRule = {
                ...rule,
                value: String(rule.value), // to do JSON Stringify on form Save all values have to be string 
                column: String(rule.value),
                operator: 'join',
                isValid: isRuleOrGroupValid(rule, validation),
            }
            return newRule
        }        
        return rule
    } catch (e) {
        return rule
    }
}

export {
    processIndependentCombinatorRules,
    restoreRuleToIndependentCombinatorForm,
    joinRuleProcessor,
}